/**
 * Task-map canvas palette — the soft-mint visual identity, extracted
 * verbatim from the wireframe SVGs (`B2-1-map-home.svg` etc.) so the built
 * surface matches the gallery. Kept in one module rather than scattered as
 * inline hexes, so the canvas/card/rail share one source of truth.
 *
 * Issue #759 (Phase 2). The brand theme tokens (`bg-subtle`, `accent`, …)
 * approximate but don't exactly reproduce the wireframe mint/teal, and
 * "beautiful is an acceptance criterion" (§A7) here means *faithful to the
 * gallery*. State colours live in `state.ts`; this is the chrome around
 * them.
 */

export const PALETTE = {
  /** Canvas background (soft mint). */
  canvas: "#EEF6F2",
  /** Node card surface. */
  cardBg: "#FFFFFF",
  /** Node card border (resting). */
  cardBorder: "#E3E6EC",
  /** Connector line. */
  connector: "#C4D4CE",
  /** Primary teal (focus ring, buttons, links). */
  teal: "#1F7A6E",
  /** Dark teal text (avatar initials, headings). */
  tealInk: "#125449",
  /** Primary heading / node title ink. */
  ink: "#0C2A2A",
  /** Muted body text. */
  muted: "#5C7878",
  /** Secondary muted (rail items). */
  slate: "#345555",
  /** Faint hint text. */
  faint: "#82A09C",
  /** Avatar circle fills (alternating, matching the gallery). */
  avatarA: "#D7ECE7",
  avatarB: "#CFE0D8",
  /** Roll-up chip background + ink. */
  rollupBg: "#D7ECE7",
  rollupInk: "#125449",
  /** Roll-up progress track + fill. */
  rollupTrack: "#E3E6EC",
  rollupFill: "#059669",
  /** Soft border on light controls. */
  softBorder: "#CFE0D8",
} as const;
